import { motion } from "framer-motion";
import { CheckCircle2, Bot, FileCheck2, MessageCircle, BellRing } from "lucide-react";
import CountUp from "./CountUp";

const kpis = [
  { label: "Orders Today", to: 24, suffix: "" },
  { label: "Chats Handled", to: 112, suffix: "" },
  { label: "SOPs Done", to: 9, suffix: "/9" },
];

const tasks = [
  { icon: FileCheck2, text: "Morning report sent", meta: "9:00 AM" },
  { icon: MessageCircle, text: "WhatsApp queries auto-replied", meta: "14 by AI" },
  { icon: BellRing, text: "Invoice reminders triggered", meta: "Auto" },
];

export default function OpsDashboard() {
  return (
    <div className="relative" data-testid="hero-dashboard">
      <p className="mb-3 text-[10px] uppercase tracking-[0.25em] text-faint" data-testid="hero-dashboard-label">
        Sample dashboard
      </p>
      <motion.div animate={{ y: [0, -12, 0] }} transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}>
        <div className="inner-glow rounded-2xl border border-line bg-surface p-5 shadow-2xl shadow-black/40">
          <div className="flex items-center justify-between border-b border-line pb-4">
            <div className="flex items-center gap-1.5">
              <span className="h-2.5 w-2.5 rounded-full bg-faint" />
              <span className="h-2.5 w-2.5 rounded-full bg-faint" />
              <span className="h-2.5 w-2.5 rounded-full bg-myrtle" />
            </div>
            <span className="text-[10px] uppercase tracking-[0.25em] text-mut">Allcov Ops Panel</span>
            <span className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-pop">
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-myrtle" />
              Live
            </span>
          </div>

          <div className="mt-4 grid grid-cols-3 gap-3">
            {kpis.map((k) => (
              <div key={k.label} className="rounded-lg border border-line bg-base p-3">
                <p className="font-batangas text-2xl tracking-tight text-txt md:text-3xl">
                  <CountUp to={k.to} suffix={k.suffix} />
                </p>
                <p className="mt-1 text-[9px] uppercase tracking-[0.18em] text-faint">{k.label}</p>
              </div>
            ))}
          </div>

          <div className="mt-4 rounded-lg border border-line bg-base p-4">
            <div className="mb-3 flex items-center justify-between">
              <span className="text-[10px] uppercase tracking-[0.2em] text-faint">Weekly Throughput</span>
              <span className="text-[10px] uppercase tracking-[0.2em] text-pop">+38%</span>
            </div>
            <svg viewBox="0 0 300 80" className="w-full" fill="none" aria-hidden="true">
              <path
                d="M0 62 C 30 58, 45 40, 70 44 S 115 60, 140 44 S 200 14, 230 22 S 285 10, 300 6 L 300 80 L 0 80 Z"
                fill="var(--pop)"
                opacity="0.08"
              />
              <path
                d="M0 62 C 30 58, 45 40, 70 44 S 115 60, 140 44 S 200 14, 230 22 S 285 10, 300 6"
                stroke="var(--pop)"
                strokeWidth="2"
                strokeDasharray="8 6"
                className="animate-dash"
              />
            </svg>
          </div>

          <div className="mt-4 space-y-2.5">
            {tasks.map((t) => (
              <div key={t.text} className="flex items-center justify-between rounded-lg border border-line bg-base px-3.5 py-2.5">
                <span className="flex items-center gap-2.5 text-xs text-mut">
                  <t.icon size={14} className="text-pop" />
                  {t.text}
                </span>
                <span className="text-[10px] uppercase tracking-[0.15em] text-faint">{t.meta}</span>
              </div>
            ))}
          </div>
        </div>
      </motion.div>

      <motion.div
        animate={{ y: [0, -10, 0] }}
        transition={{ repeat: Infinity, duration: 4.2, ease: "easeInOut", delay: 0.6 }}
        className="absolute -right-3 -top-5 hidden items-center gap-2 rounded-full border border-line bg-base px-4 py-2 shadow-lg shadow-black/30 sm:flex md:-right-6"
      >
        <CheckCircle2 size={14} className="text-pop" />
        <span className="text-[11px] uppercase tracking-[0.15em] text-mut">Report Delivered</span>
      </motion.div>
      <motion.div
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 5, ease: "easeInOut" }}
        className="absolute -bottom-5 -left-3 hidden items-center gap-2 rounded-full border border-line bg-base px-4 py-2 shadow-lg shadow-black/30 sm:flex md:-left-8"
      >
        <Bot size={14} className="text-pop" />
        <span className="text-[11px] uppercase tracking-[0.15em] text-mut">AI Active 24/7</span>
      </motion.div>
    </div>
  );
}
